import React from 'react';

import { AlertMsg } from '../../../common';

import { moneyFormatter } from '@utils/customLib';
import { getCountryProps } from '@utils/params';

export const getAppropMsg = (ref_id, status, amount, type, country) => {
	const icon = `https://bitbns.com/assets/img/coinIcons/${
		type === 'inr' ? 'rupee' : 'usdt'
	}.png`;
	const link = `/wallets/withdraw/p2p/usdt/${country}/pending/${ref_id}`;
	const upperType = type.toUpperCase();
	const { sym, numberFormat } = getCountryProps(country);

	switch (status) {
		case 0: // just matched
			return {
				alertType: 1,
				title: 'Peer Matched!',
				icon,
				text: `We found a match for your ${upperType} P2P withdraw order (${sym}${moneyFormatter(
					amount,
					undefined,
					numberFormat
				)}). Waiting for the peer to transfer`,
				links: [
					{
						text: 'Transfer Now',
						link,
						type: 0,
					},
				],
			};
		case 1: // just matched
			return {
				alertType: 1,
				title: 'Peer Has Transferred!',
				icon,
				text: `Your match for your ${upperType} P2P withdraw order (${sym}${moneyFormatter(
					amount,
					undefined,
					numberFormat
				)}) has transferred the amount. Please confirm the transfer`,
				links: [
					{
						text: 'Check Now',
						link,
						type: 0,
					},
				],
			};
		case 5: // Dispute
			return {
				alertType: -2,
				title: 'Dispute Raised!',
				icon: 'https://bitbns.com/assets/img/appIcons/svg/dispute.svg',
				text: (
					<>
						Your peer has raised a dispute against your {upperType}{' '}
						P2P transfer ({sym}
						{moneyFormatter(amount, undefined, numberFormat)}).
						<br />
						Chat with the peer/upload the documents related to the
						transfer soon
					</>
				),
				links: [
					{
						text: 'Check Now',
						link,
						type: 0,
					},
				],
			};
		case 7: // Dispute
			return {
				alertType: -2,
				title: 'Dispute Under Scrutiny!',
				icon: 'https://bitbns.com/assets/img/appIcons/svg/dispute.svg',
				text: `The dispute against your ${upperType} P2P transfer (${sym}${moneyFormatter(
					amount
				)}) has been taken over by our admins.`,
				links: [
					{
						text: 'Check Now',
						link,
						type: 0,
					},
				],
			};

		default:
			return {
				// expired
				alertType: 1,
				title: 'Cancelled!',
				icon,
				text: `Your ${upperType} P2P transfer (${sym}${moneyFormatter(
					amount,
					undefined,
					numberFormat
				)}) got cancelled.`,
				links: [
					{
						text: 'Check Now',
						link,
						type: 0,
					},
				],
			};
	}
};

const AlertsRow = ({ ref_id, status, amount, type, country }) => (
	<AlertMsg {...getAppropMsg(ref_id, status, amount, type, country)} />
);

export default AlertsRow;
